/* eslint-disable no-param-reassign  */
import CustomEmailType from 'client/settings/EmailCustomization/CustomEmailType';
import CustomEmailsApi from 'client/api/v2/CustomEmailsApi';
import Vue from 'vue';
import createModel from 'client/store/modules/models/createModel';

export function createCustomEmailModel(api = CustomEmailsApi) {
  const model = createModel(() => new CustomEmailType(), 'type', api);

  return {
    namespaced: true,

    state: {
      ...model.state,
      templates: [],
    },

    actions: {
      ...model.actions,

      async deleteItem({ dispatch, getters }, type) {
        if (getters.isItemBeingUpdated) {
          await api.delete(type);
        }

        dispatch('resetToDefaultItem', type);
      },

      async fetchItem({ commit, dispatch }, type) {
        try {
          const results = await api.get(type);
          commit('SET_ITEM', new CustomEmailType(results));
          commit('SET_PREVIOUS_ITEM', new CustomEmailType(results));
          dispatch('setItemStateToUpdate');
        } catch (exp) {
          dispatch('resetToDefaultItem', type);
        }
      },

      async getTemplates({ commit }) {
        commit('SET_TEMPLATES', await api.getTemplates());
      },

      async saveItem({ commit, getters }) {
        const handleSaveItem = (item) => {
          commit('SET_ITEM', new CustomEmailType(item));
          commit('SET_PREVIOUS_ITEM', new CustomEmailType(item));
          commit('SET_ITEM_STATE', { update: true });
          return item;
        };

        const { item } = getters;

        return getters.isItemBeingCreated
          ? api.create(item).then(handleSaveItem)
          : api.update(item).then(handleSaveItem);
      },

      resetToDefaultItem({ commit, dispatch, state }, type) {
        const currentTemplate = state.templates.find(email => email.type === type);
        const { fields } = currentTemplate;
        const defaultItemFields = fields.reduce((acc, { field, defaultValue }) => {
          acc[field] = defaultValue;
          return acc;
        }, {});

        commit('SET_ITEM', new CustomEmailType({ type, ...defaultItemFields }));
        commit('SET_PREVIOUS_ITEM', new CustomEmailType({ type, ...defaultItemFields }));
        dispatch('setItemStateToCreate');
      },
    },

    getters: {
      ...model.getters,
    },

    mutations: {
      ...model.mutations,

      SET_TEMPLATES(state, data) {
        Vue.set(state, 'templates', data);
      },
    },
  };
}

export default createCustomEmailModel();
